export function beautify(value, decision = 0) {
  return value?.toLocaleString(undefined, {
    minimumFractionDigits: decision,
  });
}
